
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"27","height":"20","viewBox":"0 0 27 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M27 8a4 4 0 00-7.877-.99c-.136.535.325.99.877.99s.979-.474 1.243-.96C21.58 6.42 22.238 6 23 6c1.105 0 2 .887 2 2 0 1.105-.89 2-2.004 2H1a1 1 0 100 2h22.003A4.001 4.001 0 0027 8zm-9-4a4 4 0 00-7.979-.416.883.883 0 00.272.707 1 1 0 001.414.002c.188-.188.281-.445.335-.704A1.994 1.994 0 0114 1.999c1.105 0 2 .888 2 2 0 1.106-.898 2-2.006 2H3a1 1 0 000 2h11.004A4 4 0 0018 4zm5 13a3 3 0 01-5.972.42c-.036-.262.078-.518.264-.706a1 1 0 011.416-.006c.187.187.27.451.375.694A.997.997 0 0020 18c.552 0 1-.444 1-1 0-.552-.449-1-1.008-1H7a1 1 0 110-2h13c1.657 0 3 1.348 3 3z","fill":"currentColor"}})])
          )
        }
      }
    